import { useContext } from 'react';

import { ListViewContext } from '../context';

const useListViewContext = () => useContext(ListViewContext);

export default useListViewContext;
